/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributesHolderIdentifier } from './AttributesHolderIdentifier';
import {
    AttributesHolderIdentifierFromJSON,
    AttributesHolderIdentifierFromJSONTyped,
    AttributesHolderIdentifierToJSON,
} from './AttributesHolderIdentifier';

/**
 * 
 * @export
 * @interface SeriesAttributeDTO
 */
export interface SeriesAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof SeriesAttributeDTO
     */
    attribute: string;
    /**
     * 
     * @type {AttributesHolderIdentifier}
     * @memberof SeriesAttributeDTO
     */
    holder: AttributesHolderIdentifier;
}

/**
 * Check if a given object implements the SeriesAttributeDTO interface.
 */
export function instanceOfSeriesAttributeDTO(value: object): value is SeriesAttributeDTO {
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('holder' in value) || value['holder'] === undefined) return false;
    return true;
}

export function SeriesAttributeDTOFromJSON(json: any): SeriesAttributeDTO {
    return SeriesAttributeDTOFromJSONTyped(json, false);
}

export function SeriesAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attribute': json['attribute'],
        'holder': AttributesHolderIdentifierFromJSON(json['holder']),
    };
}

export function SeriesAttributeDTOToJSON(value?: SeriesAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attribute': value['attribute'],
        'holder': AttributesHolderIdentifierToJSON(value['holder']),
    };
}

